import { useMutation, useQueryClient } from '@tanstack/react-query';
import { License, ManagedAccount } from '@webdev/user-management';
import { useAlerts } from '../../feedback';
import { licenseAssignationKey } from './licenseAssignationKey';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useSetManagedUsersToLicense = (licenseId: License['id']) => {
  const queryClient = useQueryClient();
  const client = useUserManagementClientContext();
  const { showError } = useAlerts();
  const { mutateAsync, status } = useMutation({
    mutationFn: (userIds: ManagedAccount['id'][]) =>
      client.setManagedUsersByLicenses({ [licenseId]: userIds }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [licenseAssignationKey] });
    },
    onError: () => {
      showError('License could not be assigned');
    },
  });
  return { setManagedUsersToLicense: mutateAsync, assigningStatus: status };
};
